"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ExtendGoogleSSOData = void 0;
var input_output_module_const_1 = require("@src/const/input-output-module.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var openstreetmap_service_1 = require("@src/services/openstreetmap.service");
var basic_const_1 = require("./basic.const");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var backend_services_1 = require("@src/services/backend-services");
var _ExtendGoogleSSOData = function (module, keycloak) { return __awaiter(void 0, void 0, void 0, function () {
    var partialCustomerData, settings, response, data, firstBirthday, _a, year, month, day, withPrefix, withoutPrefix, prefix, res, location_1, error_1;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return __generator(this, function (_s) {
        switch (_s.label) {
            case 0:
                partialCustomerData = {};
                _s.label = 1;
            case 1:
                _s.trys.push([1, 6, , 7]);
                settings = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
                return [4 /*yield*/, (0, backend_services_1.betterFetch)(basic_const_1._FitssoCloudFunction + "google-callback?realm-name=".concat(keycloak.realm, "&tenant=").concat(settings.get.tenantKey), {
                        headers: new Headers({
                            Authorization: 'Basic ' + keycloak.token,
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }),
                    })];
            case 2:
                response = _s.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                data = (_s.sent());
                if (data === null || data === void 0 ? void 0 : data.birthdays.length) {
                    firstBirthday = data.birthdays[0].date;
                    _a = [firstBirthday.year, firstBirthday.month, firstBirthday.day], year = _a[0], month = _a[1], day = _a[2];
                    partialCustomerData.dateOfBirth = "".concat(year, "-").concat(month < 10 ? '0' + month : month, "-").concat(day < 10 ? '0' + day : day);
                    partialCustomerData.monthOfBirth = String(month);
                    partialCustomerData.dayOfBirth = String(day);
                    partialCustomerData.yearOfBirth = String(year);
                }
                if ((_b = data === null || data === void 0 ? void 0 : data.phoneNumbers) === null || _b === void 0 ? void 0 : _b.length) {
                    withPrefix = (_d = (_c = data === null || data === void 0 ? void 0 : data.phoneNumbers) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.canonicalForm;
                    withoutPrefix = (_f = (_e = data === null || data === void 0 ? void 0 : data.phoneNumbers) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.value;
                    prefix = withPrefix.replace(withoutPrefix, '');
                    if (prefix === null || prefix === void 0 ? void 0 : prefix.length) {
                        (0, input_output_module_const_1._WriteField)(input_mapping_const_1._AllMappings.phonePrefix, prefix, module);
                    }
                    partialCustomerData.telephone_mobile = withoutPrefix;
                }
                if ((_g = data === null || data === void 0 ? void 0 : data.genders) === null || _g === void 0 ? void 0 : _g.length) {
                    partialCustomerData.gender = data.genders[0].value.toUpperCase();
                }
                if (!((_h = data === null || data === void 0 ? void 0 : data.addresses) === null || _h === void 0 ? void 0 : _h.length)) return [3 /*break*/, 5];
                return [4 /*yield*/, openstreetmap_service_1.OpenstreetmapService.getLocation(data.addresses[0].formattedValue, { addressDetails: true })];
            case 4:
                res = _s.sent();
                if (res.length) {
                    location_1 = res[0];
                    partialCustomerData.city = ((_j = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _j === void 0 ? void 0 : _j.town) || ((_k = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _k === void 0 ? void 0 : _k.city) || ((_l = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _l === void 0 ? void 0 : _l.village) || '';
                    partialCustomerData.houseNumber = ((_m = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _m === void 0 ? void 0 : _m.house_number) || '';
                    partialCustomerData.zipCode = ((_o = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _o === void 0 ? void 0 : _o.postcode) || '';
                    partialCustomerData.street = ((_p = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _p === void 0 ? void 0 : _p.road) || '';
                    partialCustomerData.countryCode = ((_r = (_q = location_1 === null || location_1 === void 0 ? void 0 : location_1.address) === null || _q === void 0 ? void 0 : _q.country_code) === null || _r === void 0 ? void 0 : _r.toUpperCase()) || '';
                }
                _s.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_1 = _s.sent();
                console.error("Download error: ".concat(error_1.message));
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/, partialCustomerData];
        }
    });
}); };
exports._ExtendGoogleSSOData = _ExtendGoogleSSOData;
